<template>
    <div class="vue-block">
        <div class="search-filter">
            <div class="container search-filter__content-wrapper">
                <h2 class="section-title search-filter__title">
                    Quick reorder
                </h2>
                <div class="search-filter__container">
                    <div class="search-filter__wrapper">
                        <div class="search-filter__top js-search-filter__top">
                            <span class="search-filter__top-title"
                                >Advanced search</span
                            >
                        </div>
                        <div
                            class="search-filter__body js-search-filter__body search-filter__body--active"
                        >
                            <div class="search-filter__body-top">
                                <input
                                    v-model="data.search"
                                    class="search-filter__body-top-input"
                                    @keyup="triggerSearch($event)"
                                    type="text"
                                    placeholder="Search by item title, SKU, or order number"
                                />
                                <div
                                    class="search-filter__body-icon-wrapper"
                                    @click="validation()"
                                >
                                    <SvgIcon
                                        class="search-filter__body-icon"
                                        iconName="ico-search"
                                    />
                                </div>
                                <div
                                    class="search-filter__body-top-options-wrapper"
                                >
                                    <div
                                        class="search-filter__body-top-options-container--with-img"
                                    >
                                        <span
                                            class="search-filter__body-top-options-title"
                                            >Categories</span
                                        >
                                        <VueSelect
                                            label="name"
                                            :value="terms.slug"
                                            v-model="data.term"
                                            @input="setTerms"
                                            :options="terms"
                                            :key="terms.term_id"
                                            placeholder=""
                                            transition="fade"
                                            :searchable="false"
                                        ></VueSelect>
                                    </div>
                                    <div
                                        class="search-filter__body-top-options-container"
                                    >
                                        <span
                                            class="search-filter__body-top-options-title"
                                            >Date</span
                                        >
                                        <VueSelect
                                            label="label"
                                            :value="lastday.value"
                                            v-model="data.date"
                                            @input="setLastDays"
                                            :options="lastday"
                                            placeholder=""
                                            transition="fade"
                                            :searchable="false"
                                            :disabled="!!data.from || !!data.to"
                                        ></VueSelect>
                                    </div>
                                    <div
                                        class="search-filter__body-top-options-container search-filter__body-top-options-container--calendar"
                                    >
                                        <span
                                            class="search-filter__body-top-options-title"
                                            >From</span
                                        >
                                        <input
                                            type="date"
                                            @click="clearVal()"
                                            @change="changeFromTo()"
                                            v-model="data.from"
                                            :disabled="!!data.date"
                                            class="search-filter__body-top-options-date"
                                            placeholder="MM/DD/YYYY"
                                            max="2999-12-31"
                                        />
                                    </div>
                                    <div
                                        class="search-filter__body-top-options-container search-filter__body-top-options-container--calendar"
                                    >
                                        <span
                                            class="search-filter__body-top-options-title"
                                            >To</span
                                        >
                                        <input
                                            type="date"
                                            @click="clearVal()"
                                            @change="changeFromTo()"
                                            v-model="data.to"
                                            :disabled="!!data.date"
                                            class="search-filter__body-top-options-date"
                                            placeholder="MM/DD/YYYY"
                                            max="2999-12-31"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div class="search-filter__body-bottom">
                                <a
                                    :class="[
                                        {
                                            disabled:
                                                data.isDisabled &&
                                                data.search.length < 1
                                        },
                                        'btn btn--cube js-btn--cube btn--quick-search'
                                    ]"
                                    href="javascript:;"
                                    @click="validation()"
                                    >Search</a
                                >
                                <a
                                    class="btn btn--clear"
                                    href="javascript:;"
                                    @click="clear()"
                                    >Clear Search</a
                                >
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- .search-filter -->
        <div class="quick-search-results">
            <div class="preloader-container" v-if="preloader">
                <span class="loader"></span>
            </div>
            <div
                class="quick-search-results__container container"
                v-if="
                    (changeData && mutProducts.length > 0) ||
                        (!changeData && mutProductsInit.length > 0)
                "
            >
                <div class="quick-search-results__wrap">
                    <div class="quick-search-results__wrap-info-box">
                        <span
                            class="quick-search-results__wrap-info section-title"
                            >Search Results</span
                        >
                    </div>
                    <div class="quick-search-results__wrap-date">
                        <span class="quick-search-results__wrap-date-title"
                            >Sort by</span
                        >
                        <VueSelect
                            @input="sortProduct"
                            label="label"
                            :options="orderOption"
                            placeholder="Order Date"
                            :searchable="false"
                        ></VueSelect>
                    </div>
                </div>
                <div v-if="!preloader">
                    <Product
                        v-if="changeData"
                        :products="mutProducts"
                        :cart="cart"
                        :orders="orders"
                        :addToCartLoading="addToCartLoading"
                    />
                    <Product
                        v-else
                        :products="mutProductsInit"
                        :cart="cart"
                        :orders="orders"
                        :addToCartLoading="addToCartLoading"
                    />
                    <div v-if="!changeData" style="margin:1em 0; color:#aa8; font-weight:bold;">
                        Showing the first 10 products; use filters to narrow your search.
                    </div>
                </div>

                <div
                    style="display:none"
                    class="product-listing__loader-wrapper"
                    v-if="loadMoreBtn && !changeData"
                >
                    <button
                        @click="loadMore()"
                        class="btn product-listing__loader-wrapper-btn"
                    >
                        Load more
                    </button>
                </div>
            </div>
            <div v-else-if="!preloader" class="container">
                <div class="quick-search-results__not-found">
                    <span>No products found.</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import Product from './Parts/Product.vue';
import SvgIcon from '../../base/SvgIcon/SvgIcon.vue';
import VueSelect from 'vue-select';

export default {
    components: {
        Product,
        VueSelect,
        SvgIcon
    },
    data() {
        return {
            data: {
                search: '',
                term: '',
                date: '',
                from: '',
                to: '',
                isDisabled: true
            },
            orderOption: [
                {
                    label: 'Order Date',
                    val: 'infoDate'
                },
                {
                    label: 'Price',
                    val: 'infoPrice'
                },
                {
                    label: 'Quantity',
                    val: 'infoQty'
                },
                {
                    label: 'Brand',
                    val: 'pa_brand'
                }
            ],
            lastday: [
                { label: 'Last 30 days', value: '30' },
                { label: 'Last 20 days', value: '20' },
                { label: 'Last 15 days', value: '15' },
                { label: 'Last 10 days', value: '10' }
            ],
            selectedSort: '',
            loadMoreBtn: true,
            pagination: 10,
            pages: 0,
            countPage: 1,
            mutProducts: [],
            mutProductsInit: [],
            changeData: false,
            dataOrder: 'infoDate',
            preloader: true,
            backupStore: null
        };
    },
    beforeMount() {
        this.$store.dispatch('getTerms');
        this.$store.dispatch('getAllCart');
    },
    watch: {
        products() {
            this.watchProduct();
            this.loadOnScroll();
            this.preloader = false;
        },
        productsInit() {
            this.watchProductinit();
            this.loadOnScroll();
            this.preloader = false;
        },
        ids() {
            this.pages = Math.ceil(this.ids.length / this.pagination);
            if (this.pages <= 1) {
                this.loadMoreBtn = false;
            }
        },
        'data.from'() {
            this.checkDateInputs();
        },
        'data.to'() {
            this.checkDateInputs();
        }
    },
    updated() {
        if (window.innerWidth < 992 && window.innerWidth > 550) {
            this.equalHeights('quick-search-results__item-image');
            this.equalHeights('quick-search-results__item-product');
            this.equalHeights('quick-search-results__item-order-details');
            this.equalHeights('quick-search-results__item-info');
        }
    },
    computed: mapState({
        terms: state => state.Orders.terms,
        products: state => state.Orders.products,
        productsInit: state => state.Orders.productsInit,
        orders: state => state.Orders.orders,
        ids: state => state.Orders.ids,
        addToCartLoading: state => state.Cart.addToCartLoading,
        cart: state => state.Cart.cart
    }),
    methods: {
        checkDateInputs() {
            // if both dates are entered compare them and swap values if they are in wrong order
            if (this.data.from && this.data.to) {
                const From = new Date(this.data.from);
                const To = new Date(this.data.to);
                if (From > To) {
                    [this.data.from, this.data.to] = [
                        this.data.to,
                        this.data.from
                    ];
                }
            }
        },
        triggerSearch(e) {
            this.data.isDisabled = e.target.value.length < 1;
            if (e.keyCode === 13) {
                this.validation();
            }
        },
        clearVal() {
            this.data.date = '';
        },
        changeFromTo() {
            this.data.isDisabled = false;
        },
        setLastDays(obj) {
            if (obj === null) {
                this.data.date = '';
                this.data.isDisabled = true;
            } else {
                this.data.date = obj;
                this.data.isDisabled = false;
            }
            this.data.from = '';
            this.data.to = '';
        },
        setTerms(obj) {
            if (obj === null) {
                this.data.term = '';
                this.data.isDisabled = true;
            } else {
                this.data.term = obj;
                this.data.isDisabled = false;
            }
        },
        loadMore() {
            if (this.pages === this.countPage) {
                return false;
            } else {
                this.countPage++;
            }
            const to = this.pagination * this.countPage;
            const from = to - this.pagination;
            const arr = [];
            for (let i = from; i < to; i++) {
                if (this.ids[i] !== undefined) {
                    arr.push(this.ids[i]);
                }
            }
            if (arr.length < 10) {
                this.loadMoreBtn = false;
            }
            this.$store.dispatch('loadMore', arr);
        },
        validation() {
            this.preloader = true;
            if (
                this.data.search === '' &&
                this.data.date === '' &&
                this.data.from === '' &&
                this.data.to === '' &&
                this.data.term === ''
            ) {
                this.preloader = false;
                return false;
            }
            if (!this.backupStore) {
                this.backupStore = {
                    ids: [...this.ids],
                    orders: [...this.orders],
                    products: [...this.productsInit]
                };
            }
            const obj = {
                search: this.data.search,
                from: this.data.from,
                to: this.data.to
            };
            this.data.term === ''
                ? (obj.term = '')
                : (obj.term = this.data.term.slug);

            this.data.date === ''
                ? (obj.date = '')
                : (obj.date = this.data.date.value);
            this.$store.dispatch('search', obj);
        },
        clear() {
            this.data = {
                search: '',
                term: '',
                date: '',
                from: '',
                to: '',
                isDisabled: true
            };
            this.countPage = 1;
            this.$store.commit('SET_ORDERS', this.backupStore.orders);
            this.$store.commit('SET_PRODUCTS', this.backupStore.products);
            this.$store.commit('SET_IDS', this.backupStore.ids);
            setTimeout(() => this.changeData = false, 500);
        },
        watchProductinit() {
            const products = this.productsInit;
            let arr = [];
            const orders = this.orders;
            products.map(product => {
                product.infoOrder = '';
                product.infoQty = 0;
                product.infoOrderLink = [];
                product.infoDate = '';
                const obj = orders.filter(obje => product.ID === obje.ID);
                if (obj.length !== 0) {
                    if (obj.length > 1) {
                        obj.forEach(element => {
                            product.infoDate =
                                element.date > product.infoDate
                                    ? element.date
                                    : product.infoDate;
                            product.infoOrderLink.push(element.order);
                            if (product.infoOrder) {
                                product.infoOrder += ', ' + element.order;
                            } else {
                                product.infoOrder = element.order;
                            }
                            if (product.infoQty) {
                                product.infoQty += element.qty;
                            } else {
                                product.infoQty = element.qty;
                            }
                        });
                    } else {
                        product.infoDate = obj[0].date;
                        product.infoOrder = obj[0].order;
                        product.infoQty = obj[0].qty;
                    }
                }
                product.infoOrderLink = [...new Set(product.infoOrderLink)]; // remove duplicates
                product.infoPrice = parseFloat(product.price);
                arr.push(product);
            });
            arr = arr.sort(
                this.dataOrder === 'pa_brand' || this.dataOrder === 'infoPrice'
                    ? this.compare // pa_brand, infoPrice
                    : this.compareInv // infoDate, infoQty
            );
            this.mutProductsInit = arr;
        },
        compareInv(a, b) {
            return -this.compare(a, b);
        },
        compare(a, b) {
            if (a[this.dataOrder] < b[this.dataOrder]) {
                return -1;
            }
            if (a[this.dataOrder] > b[this.dataOrder]) {
                return 1;
            }
            return 0;
        },
        watchProduct() {
            const products = this.products;
            let arr = [];
            const orders = this.orders;
            products.map(product => {
                product.infoOrder = '';
                product.infoQty = 0;
                product.infoOrderLink = [];
                product.infoDate = '';
                const obj = orders.filter(obje => product.ID === obje.ID);
                if (obj.length !== 0) {
                    if (obj.length > 1) {
                        obj.forEach(element => {
                            product.infoDate =
                                element.date > product.infoDate
                                    ? element.date
                                    : product.infoDate;
                            product.infoOrderLink.push(element.order);
                            if (product.infoOrder) {
                                product.infoOrder += ', ' + element.order;
                            } else {
                                product.infoOrder = element.order;
                            }
                            if (product.infoQty) {
                                product.infoQty += element.qty;
                            } else {
                                product.infoQty = element.qty;
                            }
                        });
                    } else {
                        product.infoDate = obj[0].date;
                        product.infoOrder = obj[0].order;
                        product.infoQty = obj[0].qty;
                    }
                }
                product.infoOrderLink = [...new Set(product.infoOrderLink)]; // remove duplicates
                product.infoPrice = parseFloat(product.price);
                arr.push(product);
            });
            this.changeData = true;
            arr = arr.sort(
                this.dataOrder === 'pa_brand' || this.dataOrder === 'infoPrice'
                    ? this.compare // pa_brand, infoPrice
                    : this.compareInv // infoDate, infoQty
            );
            this.mutProducts = arr;
        },
        sortProduct(value) {
            if (value === null) {
                this.dataOrder = 'infoDate';
            } else {
                this.dataOrder = value.val;
            }
            if (this.changeData) {
                // mutate search
                this.watchProduct();
            } else {
                // init product
                this.watchProductinit();
            }
        },
        loadOnScroll() {
            window.onscroll = () => {
                const products = document.querySelector('.js-product-listing');
                const productsHeight = products.scrollHeight;
                const viewportHeight = window.innerHeight;
                const scrollPosition = window.scrollY;
                const scrollThreshold = productsHeight - viewportHeight * 0.5;

                if (scrollPosition >= scrollThreshold) {
                    this.loadMore();
                }
            };
        },

        /**
         * @description add equal height to products title
         */
        equalHeights: elName => {
            setTimeout(() => {
                const products = document.getElementsByClassName(elName);
                let x = 0;

                Array.from(products).forEach(el => {
                    el.style.height = 'auto';
                    if (el.offsetHeight > x) {
                        x = el.offsetHeight;
                    }
                });

                Array.from(products).forEach(el => {
                    el.style.height = `${x}px`;
                });
            }, 2000);
        }
    }
};
</script>

<style lang="scss" scoped>
.quick-search-results {
    position: relative;
    min-height: 300px;

    @include mq($lg) {
        min-height: 100px;
    }

    .preloader-container {
        position: absolute;
        top: 0;
        left: 0;

        @include mq($lg) {
            position: relative;
            top: auto;
            left: auto;
        }

        .loader {
            top: 20%;
            transform: translate(0, -50%);

            @include mq($lg) {
                font-size: 35px;
            }
        }
    }
}

.search-filter__body-icon {
    position: absolute;
    top: 11px;
    right: 15px;
    font-size: 38px;
    height: 38px;
    cursor: pointer;
}

.search-filter__body-top-options {
    width: 100%;
    height: 58px;
    border-radius: 6px;
    border: 1px solid transparent;
    background-color: #fff;
    display: flex;
    align-items: center;
}

.search-filter__body-top-options--with-img {
    border: 1px solid #00be9d;
}

.product-listing__loader-wrapper-btn {
    margin-top: 35px;
}

.btn--quick-search {
    pointer-events: auto;
    opacity: 1;

    &.disabled {
        pointer-events: none;
        opacity: 0.5;
    }
}

input:disabled {
    cursor: not-allowed;
    background-color: #f8f8f8;
}
</style>
